import { useCreateSavedAST } from '@api';
import { QueryBuilderShareQueryConfigType, useNotification } from '@common';
import { AxiosError } from 'axios';
import { useMemo } from 'react';
import { Route } from 'src/routes/_rootLayout/projects/sales';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.SHARE_QUERY';

type UseShareQueryReturnType = {
  shareQuery: QueryBuilderShareQueryConfigType;
};

export const useShareQuery = (): UseShareQueryReturnType => {
  const navigate = Route.useNavigate();
  const { showSuccess, showError } = useNotification();
  const { mutate: createSavedAST } = useCreateSavedAST();

  const shareQuery = useMemo(
    (): QueryBuilderShareQueryConfigType => ({
      mutate: (ast, { onSuccess, onError }): void => {
        createSavedAST(
          { data: { ast, context: 'TICKET_SALES' } },
          {
            onSuccess: (response): void => {
              onSuccess(response.data.id);
            },
            onError,
          }
        );
      },
      buildShareUrl: (uuid): string =>
        `${window.location.origin}/projects/sales?sharedAst=${uuid}`,
      onSuccess: (uuid): void => {
        showSuccess({
          title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
          message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
        });
        navigate({ search: { sharedAst: uuid }, replace: true });
      },
      onError: (error: unknown): void => {
        showError({
          title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
          message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
          error: error as AxiosError,
        });
      },
    }),
    [createSavedAST, navigate, showError, showSuccess]
  );

  return { shareQuery };
};
